import "./newNavbar.scss";

import React, { useEffect, useRef, useState } from "react";
import { graphql, useStaticQuery } from "gatsby";

import DropdownMenu from "../dropdown-menu/dropdownMenu";
import DropdownMenuMobile from "../dropdown-menu-mobile/dropdownMenuMobile";
import Follows from "../follows/follows";
import Login from "../../atoms/login/login";
import classNames from "classnames";
import imagePull from "../../../assets/images/logos/comfama/magenta.svg";

const NewNavbar = () => {
  const [openMenu, setOpenMenu] = useState(false);
  const refMobileContainer: any = useRef(null);
  const checkboxRef: any = useRef(null);

  const [isMenuIconClicked, setIsMenuIconClicked] = useState(false);

  const data = useStaticQuery(graphql`
    query FOOTER_CONTENT_MENU {
      allContentfulFooter(
        filter: { titulo: { eq: "Footer nutricion saludable" } }
      ) {
        nodes {
          titulo
          categorias {
            nombreCategoria
            noVisibleFooter
            referenciaSubcategorias {
              titulo
              slug
              link
              nombreSubcategoria
              tipoCampo
            }
          }
        }
      }
      allContentfulMenuLoggin(
        filter: { titulo: { eq: "Menu login nutricion saludable" } }
      ) {
        nodes {
          inicioSesion
        }
      }
    }
  `);

  // Agendar cita services
  const scheduleAppointmentServices = [];

  const nutritionistsServices = [
    {
      slug: "/servicios/nutricionistas/cita-individual-de-nutrición/",
      anchor: "Cita individual de nutrición",
    },
    //   TODO: se comenta temporalmente las otras opciones de redireccionamiento, por lógica de negocio
    //  {
    //    slug: "/servicios/nutricionistas/nutricionista-infantil/",
    //    anchor: "Nutricionista infantil",
    //  },
    //  {
    //    slug: "/servicios/nutricionistas/nutricionista-para-adolescentes/",
    //    anchor: "Nutricionista para adolescentes",
    //  },
    //  {
    //    slug: "/servicios/nutricionistas/nutricionista-para-deportistas/",
    //    anchor: "Nutricionista para deportistas",
    //  },
  ];

  const nutritionalPlansServices = [
    {
      slug:
        "/servicios/planes-nutricionales/plan-nutricional-para-aumentar-masa-muscular/",
      anchor: "Para aumentar masa muscular",
    },
    {
      slug:
        "/servicios/planes-nutricionales/plan-nutricional-para-bajar-de-peso/",
      anchor: "Para bajar de peso",
    },
    {
      slug:
        "/servicios/planes-nutricionales/plan-nutricional-para-subir-de-peso/",
      anchor: "Para subir de peso",
    },
    {
      slug: "/servicios/planes-nutricionales/plan-para-alimentarse-mejor/", //TODO: need to check it
      anchor: "Para alimentarse mejor",
    },
    {
      slug:
        "/servicios/planes-nutricionales/plan-nutricional-para-deportistas/", //TODO: need to check it
      anchor: "Para Deportistas",
    },
  ];

  const libraryServices = [
    {
      slug: "/biblioteca/trastornos-alimenticios/", //TODO: still need the path.
      anchor: "Trastornos alimenticios",
    },
    {
      slug: "/biblioteca/hábitos-alimenticios/", //TODO: still need the path.
      anchor: "Hábitos alimenticios",
    },
    {
      slug: "/biblioteca/dietas/", //TODO: still need the path.
      anchor: "Dietas",
    },
    {
      slug: "/biblioteca/alimentos-y-nutrientes/", //TODO: still need the path.
      anchor: "Alimentos y nutrientes",
    },
  ];

  const queryFooter: any = data?.allContentfulFooter?.nodes?.[0]?.categorias;

  const renderLoginButton = () => {
    const loginButton = (
      <Login isMenuActive={true} title={"Iniciar sesión"}></Login>
    );
    return loginButton;
  };

  useEffect(() => {
    // Función manejadora del clic fuera del contenedor
    const handleClickOutside = (event) => {
      if (
        refMobileContainer.current &&
        !refMobileContainer.current.contains(event.target) &&
        isMenuIconClicked
      ) {
        // Clic fuera del contenedor, cambia el estado
        setOpenMenu(false);
        setIsMenuIconClicked(false);

        if (checkboxRef.current) {
          checkboxRef.current.click();
        }
      }
    };

    // Agrega un event listener al documento para el clic
    document.addEventListener("click", handleClickOutside);

    // Limpia el event listener al desmontar el componente
    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, [refMobileContainer, isMenuIconClicked]);

  return (
    <header className="m-header">
      <div className="m-new__navbar">
        <a href="/nutricion-saludable" className="m-new__navbar-logo">
          <img src={imagePull} alt="" />
        </a>
        <div className="m-login__mobile-render">{renderLoginButton()}</div>

        <hr className="m-separator"></hr>

        <div className="m-new__navbar-login--mobile">
          <Login
            isMenuActive={true}
            title={data?.allContentfulMenuLoggin?.nodes?.[0]?.inicioSesion}
          />
        </div>

        <hr className="m-separator"></hr>

        <div className="m-nav__container">
          <input
            className="m-checkbox"
            type="checkbox"
            ref={checkboxRef}
            onClick={() => {
              setIsMenuIconClicked(!isMenuIconClicked);
              setTimeout(() => {
                setOpenMenu(!openMenu);
              }, 0);
            }}
          />
          <div className="m-hamburger__lines">
            <span className="line line1"></span>
            <span className="line line2"></span>
            <span className="line line3"></span>
          </div>
        </div>

        <div className="m-new__navbar-dropdown--mobile">
          <div className="m-new__navbar-dropdown--mobile__items">
            {openMenu && (
              <section
                className={classNames("menu-overlay")}
                ref={refMobileContainer}
              >
                {/* <span className="title">Agenda una cita</span> */}
                {/* <DropdownMenuMobile dropdownTitle="Agendar cita" /> TODO: temporal change, el negocio decidió que temporalmente esto no irá */}
                <DropdownMenuMobile
                  dropdownTitle="Nutricionistas"
                  items={nutritionistsServices}
                />
                <DropdownMenuMobile
                  dropdownTitle="Planes nutricionales"
                  items={nutritionalPlansServices}
                />
                {/* Se comenta mientras se termina el desarrollo */}
                {/* <DropdownMenuMobile
                  dropdownTitle="Biblioteca"
                  items={libraryServices}
                /> */}
                <hr />
                <Follows query={queryFooter?.[4]} iconsForMobile />
                <h3 className="container-footer">
                  Conoce más en <a>Comfama.com</a>
                </h3>
              </section>
            )}
          </div>
        </div>
      </div>
      <div className="m-new__navbar-dropdown">
        <div className="m-new__navbar__dropdown__items">
          {/* <DropdownMenu dropdownTitle="Agendar cita" />
          {"|"} TODO: temporal change, el negocio decidió que temporalmente esto no irá*/}
          <DropdownMenu
            dropdownTitle="Nutricionistas"
            items={nutritionistsServices}
          />
          {"|"}
          <DropdownMenu
            dropdownTitle="Planes nutricionales"
            items={nutritionalPlansServices}
          />
          {/* Se comenta mientras se termina el desarrollo */}
          {/* {"|"}
          <DropdownMenu dropdownTitle="Biblioteca" items={libraryServices} /> */}
        </div>
      </div>
    </header>
  );
};

export default NewNavbar;
